const escapeHtml = (value) => {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
};

const REASONS_REQUIRING_NOTE = ['app_issues', 'software_issues'];

const promptSourceReason = (sourceReasons) => {
    const optionsHtml = Object.entries(sourceReasons)
        .map(([value, label]) => `<option value="${escapeHtml(value)}">${escapeHtml(label)}</option>`)
        .join('');

    return window.swal
        .fire({
            title: 'Why is this WTN being created here instead of via the app?',
            html: `
                <select id="swal-source-reason" class="swal2-select" style="display:block;width:100%;">
                    <option value="" selected disabled>Select a reason</option>
                    ${optionsHtml}
                </select>
                <input
                    id="swal-source-reason-note"
                    type="text"
                    class="swal2-input"
                    placeholder="Please explain"
                    style="display:none;"
                >
            `,
            showCancelButton: true,
            confirmButtonText: 'Continue',
            focusConfirm: false,
            onOpen: () => {
                const select = document.getElementById('swal-source-reason');
                const note = document.getElementById('swal-source-reason-note');

                select.addEventListener('change', () => {
                    note.style.display = REASONS_REQUIRING_NOTE.includes(select.value) ? 'block' : 'none';
                });
            },
            preConfirm: () => {
                const select = document.getElementById('swal-source-reason');
                const note = document.getElementById('swal-source-reason-note');

                if (!select.value) {
                    window.swal.showValidationMessage('Please select a reason');
                    return false;
                }

                if (REASONS_REQUIRING_NOTE.includes(select.value) && !note.value) {
                    window.swal.showValidationMessage('Please specify a reason');
                    return false;
                }

                return {
                    value: select.value,
                    label: select.options[select.selectedIndex].text,
                    note: note.value,
                };
            },
        })
        .then((result) => {
            if (!result.value) {
                return null;
            }

            return {
                source_reason: { value: result.value.value, label: result.value.label },
                source_reason_note: result.value.note || '',
            };
        });
};

export default promptSourceReason;
